// Single source of truth for all copy + shared constants.

// All CTA buttons link here (Shopify checkout).
export const CART_LINK =
  'https://tupolleriarentable.com/cart/67350748004656:1?checkout'

// Prices are expressed in the product's base currency (ARS).
// The numeric values below are the "raw" amounts; PriceDisplay formats them.
export const PRICE = {
  today: 29999,
  next: 59999,
  crossed: [99999, 59999] as const,
  totalValue: 349999,
}

export const HERO = {
  eyebrow:
    'Se Anuncia: El Sistema Más Completo Para Montar y Hacer Rentable Tu Pollería en 30 Días',
  soundNote:
    'Asegurate de tener el sonido activado. Por favor esperá unos segundos a que cargue el video.',
  headline:
    'Mirá Este Video Hasta El Final Y Accedé A Los 20+ Videos, Las 3 Calculadoras y Todos Los Bonos',
  offerLabel: 'Oferta de Lanzamiento',
  cta: 'AGREGAR AL CARRITO',
  ctaSub: 'Accedé Ahora Mismo A Pollería Rentable 2026 »',
  singlePayment: 'Esto es un pago único.',
  scarcity:
    'Me reservo el derecho de cerrar esta oferta en cualquier momento después del 9 de agosto de 2026.',
}

export const PAIN_INTRO = {
  from: 'Desde el Escritorio de Franco R.',
  re: 'Re: Cómo hacer rentable tu pollería sin roturas de cabeza…',
  greeting: 'Estimado Colega Pollero,',
  question: '¿Alguna vez…?',
}

export const PAINS = [
  'Trabajaste de sol a sol atendiendo el mostrador y a fin de mes casi no te quedó nada, sin entender por qué si «vendés bien»?',
  'Le diste vueltas a la idea de abrir tu propia pollería pero tuviste miedo de fundirte, sin saber cuánto invertir, dónde ni si te iba a alcanzar?',
  'Sentiste que el trámite de habilitación y bromatología te paralizaba, convencido de que era imposible o carísimo para alguien como vos?',
  'Sospechaste que el pollo que te manda tu proveedor viene «inyectado» — pagando agua a precio de pollo — pero no tuviste forma de comprobarlo?',
  'Pusiste tus precios «a ojo», sin saber tu costo real por kilo, viendo cómo la merma se te come la ganancia sin que la veas venir?',
]

export const STORY_BLOCKS: string[] = [
  'Estos son los mismos problemas que yo enfrenté cuando recién arrancaba con un cajón de pollo prestado…',
  '…y son los mismos problemas que siguen frenando hoy a cientos de polleros y polleras de barrio en toda la Argentina.',
]

export const AUTHOR = {
  name: 'Franco R.',
  bio: 'Pollero de toda la vida. Pasé de un cajón de pollo a mi propio local. Creador de Pollería Rentable 2026.',
  img: 'https://images.unsplash.com/photo-1607990281513-2c110a25bd8c?auto=format&fit=crop&w=400&q=80',
}

export const PROBLEM_SECTION = {
  title: 'Acá Está El Gran Problema…',
  intro:
    'Cuando yo arrancaba y buscaba ayuda para no fundirme, esto fue lo que encontré: la mayoría de los «consejos» gratis para poner una pollería son BASURA PURA.',
  subtitle: 'Fijate por qué:',
  bullets: [
    'Los videos de YouTube y TikTok solo enseñan pollo a la brasa peruano — nada que ver con la realidad de un mostrador argentino, un cajón crudo y un cliente que te discute el precio del kilo.',
    'Los «consejos» del cuñado, del vecino o del amigo que «una vez vendió pollo» — que nunca pusieron un peso propio ni sostuvieron un local un mes entero.',
    'Los cursos genéricos de emprendedurismo del Estado, llenos de power points y cero cancha — nunca te dicen cuánto rinde un cajón ni cómo detectar que te están metiendo agua por pollo.',
    'Pagarle todos los meses a un contador por algo que, con las herramientas correctas, podés resolver vos mismo en cinco minutos desde el celular.',
  ],
  outro: [
    'Vi a un pibe abrir con toda la garra, comprar el cajón más caro pensando que así ganaba más, y terminar regalando la mitad del pollo porque no sabía calcular el rinde ni el precio de venta.',
    'Otro me contó que descubrió recién al tercer mes que el «pollo fresco» que le vendían pesaba distinto según el día — nadie le había explicado cómo pesar el hielo y el agua para no pagar de más.',
    'Así que agarré papel, calculadora y años de mostrador, y le armé el cálculo real, cajón por cajón, para que no le pasara lo mismo a nadie más.',
  ],
}

export const SOLUTION_INTRO = {
  title: 'Así Que Decidí Solucionar Todo Eso…',
  paragraphs: [
    'Por suerte para vos, esos problemas se convirtieron en una bendición disfrazada.',
    'Porque me pasé más de una década parado en el mostrador, cortando, pesando, cobrando y aprendiendo a los golpes — para armar el sistema más completo para montar y hacer rentable una pollería en Argentina.',
    'Este método fue probado con pollo real, cajones reales y clientes reales — no lo vas a encontrar en ningún curso genérico ni en ningún video de recetas.',
  ],
}

export const PRODUCT_REVEAL = {
  kicker: 'Te Presento…',
  name: 'Pollería Rentable 2026',
  tagline:
    '«El Sistema Completo Para Iniciar y Hacer Rentable Tu Negocio de Venta de Pollo»',
  promise:
    'Montá y hacé rentable tu pollería en 30 días — sacándole hasta un 30% más de ganancia al mismo cajón de pollo que ya estás comprando…',
  promise2:
    '…aunque hoy no tengas ni idea de bromatología, ni sepas calcular un rinde, ni tengas ni un peso ahorrado de más.',
}

export const FEATURES = [
  {
    tag: 'Característica #1',
    title: 'El Módulo de los Secretos',
    body: 'Te enseño, con el pollo en la mano, cómo detectar si el pollo que te venden viene inyectado con agua, cómo sacarle el máximo rinde a cada cajón y cómo no tirar ni los menudos.',
    note: 'Es como tener a un pollero de toda la vida parado al lado tuyo en el mostrador, mostrándote exactamente dónde está la plata que hoy estás dejando pasar.',
    img: 'https://images.unsplash.com/photo-1587593810167-a84920ea0781?auto=format&fit=crop&w=900&q=80',
  },
  {
    tag: 'Característica #2',
    title: '3 Calculadoras Listas Para Usar Desde El Celu',
    body: 'Te llevás la Calculadora de Rinde del Pollo, la Calculadora para Marcar Precios y la Lista de Proveedores — todas listas para completar con tus propios números.',
    note: 'Se acabó lo de poner precios «a ojo». Vas a saber tu costo real por kilo antes de abrir la persiana cada mañana.',
    img: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=900&q=80',
  },
  {
    tag: 'Característica #3',
    title: 'Habilitación, Bromatología y Cobros — Paso a Paso',
    body: 'La parte que nadie enseña: cómo resolver la habilitación municipal y la bromatología sin perderte en trámites, y cómo cobrar con Mercado Pago sin que las comisiones te coman la ganancia del día.',
    note: 'Cuando las instrucciones son así de claras, el trámite deja de ser una montaña. Se resuelve solo, un paso a la vez.',
    img: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=900&q=80',
  },
  {
    tag: 'Característica #4',
    title: 'Método Probado En La Vida Real, No En Un Aula',
    body: 'Todo adaptado a proveedores, precios y trámites argentinos — no a recetas peruanas ni a manuales genéricos traducidos de otro país.',
    note: 'Vas a ver exactamente cómo se hace, filmado por un pollero de verdad, no explicado por alguien que jamás pesó un cajón.',
    img: 'https://images.unsplash.com/photo-1519861531473-9200262188bf?auto=format&fit=crop&w=900&q=80',
  },
  {
    tag: 'Característica #5',
    title: 'Sirve Para El Que Empieza Y Para El Que Ya Tiene Un Local',
    body: 'Tenemos módulos para el que arranca de cero y también para el que ya tiene su pollería hace años pero siente que labura para el proveedor y no le queda nada.',
    note: 'No hace falta que seas contador ni que tengas un local enorme. Ya sea que estés por abrir tu primer cajón o que quieras por fin sacarle rentabilidad real al local que ya tenés, hay un módulo hecho para tu situación.',
    img: 'https://images.unsplash.com/photo-1606787366850-de6330128bfc?auto=format&fit=crop&w=900&q=80',
  },
]

export const TESTIMONIALS = [
  {
    title: 'El Mejor Sistema Que Vi Para Esto',
    quote:
      'Probé de todo: videos, cuñados, hasta un curso del municipio. Nada bajaba a la realidad del mostrador como esto. Las calculadoras solas ya me cambiaron el mes. Si estás por abrir, esto es una ganga.',
    name: 'Rubén A.',
    location: 'La Matanza',
    img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80',
  },
  {
    title: 'Por Fin Entendí Por Qué No Me Quedaba Plata',
    quote:
      'Tengo la pollería hace 4 años y pensaba que «así era el negocio». Con el módulo de rinde me di cuenta que estaba regalando casi el 20% del cajón sin saberlo. Ahora lo primero que hago cada mañana es la cuenta con la calculadora.',
    name: 'Marisa D.',
    location: 'Rosario',
    img: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80',
  },
  {
    title: 'Me Sacó El Miedo De Encima',
    quote:
      'Lo que más me frenaba era la habilitación, pensaba que era un quilombo carísimo. Acá está explicado paso a paso, sin vueltas. Ya arranqué el trámite y no fue ni la mitad de lo que imaginaba.',
    name: 'Walter C.',
    location: 'Córdoba',
    img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80',
  },
  {
    title: 'Se Nota Que Lo Grabó Alguien Que Labura De Esto',
    quote:
      'No es un curso de power point. Es un pollero de verdad con el pollo en la mano, mostrándote todo. Eso se nota y se agradece.',
    name: 'Yamila S.',
    location: 'San Miguel de Tucumán',
    img: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=200&q=80',
  },
]

export const INCLUDES = [
  {
    title: '+20 Videos En 11 Módulos',
    desc: 'de la mentalidad al mostrador, filmados por un pollero de verdad, con el pollo en la mano.',
    value: 150000,
  },
  {
    title: 'El Módulo de los Secretos',
    desc: 'cómo detectar pollo inyectado, sacarle el máximo rinde al cajón y no tirar ni los menudos.',
  },
  {
    title: 'Acceso de Por Vida',
    desc: 'mirá los videos las veces que quieras, desde el celu, cuando lo necesites.',
  },
  {
    title: 'Trámites Resueltos',
    desc: 'habilitación, bromatología y cobros con Mercado Pago, paso a paso.',
  },
  {
    title: 'Método 100% Argentino',
    desc: 'adaptado a proveedores, precios y trámites reales, no a manuales de otro país.',
  },
]

export const BONUSES = [
  {
    n: 1,
    title: 'Calculadora de Rinde del Pollo',
    desc: 'Sacá tu costo real por kilo, sin adivinar. Esta es la misma planilla que uso yo para saber exactamente cuánto me queda de cada cajón antes de ponerle un precio a la carne.',
    value: 25000,
    img: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=500&q=80',
  },
  {
    n: 2,
    title: 'Calculadora Para Marcar Precios',
    desc: 'A cuánto vender cada corte para ganar de verdad, no para «cubrir gastos». Cargás tus números y te tira el precio de venta que te garantiza margen.',
    value: 12900,
    img: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=500&q=80',
  },
  {
    n: 3,
    title: 'Lista de Proveedores',
    desc: 'La pieza clave para que no te claven precio ni te vendan pollo de dudosa procedencia. Un listado armado con años de mostrador para que arranques con proveedores serios, no a ciegas.',
    value: 20000,
    img: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=500&q=80',
  },
  {
    n: 4,
    title: '"Qué Hacer Con Lo Que Tirás"',
    desc: 'Una mini-guía de aprovechamiento para que dejes de tirar plata a la basura junto con los descartes. Menudos, huesos y recortes que hoy tirás, mañana te generan un ingreso extra.',
    value: 25000,
    img: 'https://images.unsplash.com/photo-1615486511484-92e172cc4fe0?auto=format&fit=crop&w=500&q=80',
  },
]

export const FAQS = [
  {
    q: '¿Cómo accedo a los videos y las calculadoras? ¿Me llega algo a casa?',
    a: 'Todo es digital. Vas a cargar tus datos en la página siguiente y al toque tenés acceso a la plataforma con todos los videos, las 3 calculadoras y los 4 bonos. No hay cuota mensual de ningún tipo. Pagás una sola vez y eso es todo.',
  },
  {
    q: 'No tengo plata para arrancar en grande. ¿Esto me sirve igual?',
    a: 'Justamente por eso está armado así. No hace falta arrancar con el local más grande ni con la heladera más cara. Yo arranqué con un cajón prestado y de ahí salió todo. El sistema te muestra cómo escalar de a poco, sin fundirte en el intento.',
  },
  {
    q: '¿Hay alguna cuota mensual?',
    a: 'NO. Si entrás con esta oferta, es un pago único de $29.999 por acceso de por vida a todo el sistema y los bonos.',
  },
  {
    q: '¿Por qué el descuento es tan grande? ¿Cuál es el truco?',
    a: 'No hay truco. Es una oferta de lanzamiento por tiempo limitado para premiar a los que se deciden rápido. Cuando esta página se actualice, el precio va a subir a $59.999. Pero para los que llegan a tiempo, el precio es un pago único de $29.999.',
  },
  {
    q: '¿Y si recién estoy arrancando y no sé nada del tema?',
    a: 'Creo que cualquiera puede aprender a llevar una pollería rentable. El sistema arranca desde cero, explicando todo paso a paso, incluida la mentalidad antes que la técnica. Si podés seguir instrucciones simples, podés seguir este sistema.',
  },
  {
    q: 'Ya tengo mi pollería hace años. ¿Esto me sirve o es solo para el que arranca?',
    a: 'Te sirve especialmente a vos. Varios módulos están pensados justo para el que ya tiene el local pero siente que labura para el proveedor y no le queda nada — ahí es donde más plata se recupera con el módulo de rinde y las calculadoras.',
  },
  {
    q: '¿Cómo funciona la garantía? Quiero estar seguro de que es segura.',
    a: 'Solo debés compartir tus datos con quien confiás al 100%. Tu compra queda protegida con mi garantía de 30 días. Si no te convence por cualquier motivo, me escribís y te devuelvo el 100% de tu plata, sin preguntas ni letra chica.',
  },
  {
    q: '¿Por cuánto tiempo tengo acceso al sistema?',
    a: 'Tenés acceso de por vida a todos los videos, calculadoras y bonos. Tu acceso nunca vence y podés volver a mirar cualquier módulo cuando lo necesites.',
  },
]
